/*
  PPV Rabatt-Spiel – Spiellogik zu sections/ppv-flappy.liquid
  Datei: assets/ppv-flappy.js (wird von der Section mit defer geladen, auch bei mehreren Sections nur einmal ausgeführt)
*/
(() => {
  if (window.PPVFlappy) { window.PPVFlappy.scan(); return; }

  // Spielwelt in Einheiten: Spielfeld immer 640 hoch, mindestens 420 breit (Handy: mehr Himmel und Boden statt weniger Sicht)
  const H = 640, MIN_W = 420, STEP = 1 / 240, MAX_DT = 0.1;
  const GRAVITY = 1650, FLAP = -480, MAX_FALL = 760;
  const PIPE_W = 68, CAP_W = 80, CAP_H = 22, FLOOR = 22, BIRD = 46, HIT_R = 17;
  const RAMP = 40;   // bis zu diesem Punktestand wird es schrittweise schneller und enger
  const LEVELS = {
    easy:   { gap: [216, 194], speed: [160, 188], spacing: 300, shift: 150 },
    medium: { gap: [194, 168], speed: [175, 214], spacing: 285, shift: 175 },
    hard:   { gap: [172, 150], speed: [195, 238], spacing: 272, shift: 200 }
  };
  const BLUE = 'rgba(43,63,184,', GOLD = 'rgba(196,170,120,';
  const CONFETTI = ['#2b3fb8', '#2a3889', '#c4aa78', '#d9c7a2', '#8e9be0'];
  const KEY = 'ppv-flappy';
  const instances = new Set();
  const motion = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const save = (d) => { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} };
  const decode = (b64) => {
    try { const bin = atob(b64); try { return decodeURIComponent(escape(bin)); } catch (e) { return bin; } } catch (e) { return ''; }
  };
  // wie Liquid-handleize: "#Rabatt Spiel" und "#rabatt-spiel" sind derselbe Anker
  const ACCENTS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  const norm = (s) => String(s || '').toLowerCase().normalize('NFKD').replace(ACCENTS, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const rr = (c, x, y, w, h, r) => {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    c.beginPath();
    c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r);
    c.closePath();
  };
  const hitRect = (cx, cy, r, x0, y0, x1, y1) => {
    const dx = cx - clamp(cx, x0, x1), dy = cy - clamp(cy, y0, y1);
    return dx * dx + dy * dy < r * r;
  };
  // Transparente Ränder des Logos abschneiden, damit Figur und Trefferzone zusammenpassen
  const trim = (img) => {
    const w = img.naturalWidth, h = img.naturalHeight, full = { img, sx: 0, sy: 0, sw: w, sh: h };
    try {
      const cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      const x = cv.getContext('2d');
      x.drawImage(img, 0, 0);
      const d = x.getImageData(0, 0, w, h).data;
      let x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (let y = 0; y < h; y++) for (let i = 0; i < w; i++) {
        if (d[(y * w + i) * 4 + 3] > 16) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      return x1 < 0 ? full : { img, sx: x0, sy: y0, sw: x1 - x0 + 1, sh: y1 - y0 + 1 };
    } catch (e) { return full; }
  };

  class Game {
    constructor(root) {
      this.root = root;
      const d = root.dataset, q = (sel) => root.querySelector(sel);
      this.target = Math.max(1, parseInt(d.target, 10) || 50);
      this.L = LEVELS[d.level] || LEVELS.medium;
      this.anchor = norm(d.anchor) || 'rabattspiel';
      this.key = d.c || '';
      this.code = decode(this.key);
      this.autoApply = d.apply === 'true';
      this.stage = q('.fl-stage');
      this.canvas = this.stage.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d');
      this.dialog = q('.fl-dialog');
      this.slot = q('.fl-slot');
      this.home = q('.fl-home');
      this.ov = { start: q('[data-ov="start"]'), over: q('[data-ov="over"]'), won: q('[data-ov="won"]'), pause: q('[data-ov="pause"]') };
      this.el = {
        score: q('.fl-score'), fill: q('.fl-prog i'), sr: q('.fl-sr'),
        msg: q('[data-fl-msg]'), final: q('[data-fl-final]'), best: q('[data-fl-best]'), showCode: q('[data-fl="code"]'),
        wonTitle: q('[data-fl-won]'), code: q('[data-fl-code]'), copy: q('[data-fl-copy]'), note: q('[data-fl-note]')
      };
      this.W = MIN_W; this.k = 1; this.oy = 0; this.bx = 110;
      this.t = 0; this.drift = 0; this.floorX = 0; this.flash = 0; this.lock = 0;
      this.pipes = []; this.parts = []; this.score = 0; this.wonRun = false;
      this.bird = { x: 110, y: H * 0.44, vy: 0, rot: 0 };
      this.restY = H * 0.44;
      this.raf = 0; this.last = 0; this.acc = 0;
      this.inView = !this.home;
      this.saved = load();
      this.frame = this.frame.bind(this);
      this.makeBlob();
      // Logo sofort nur, wenn es ohnehin sichtbar ist (Kachel, direkt spielbar); reines Popup lädt es erst beim Öffnen
      this.logoUrl = d.logo;
      if (this.home || q('.fl-comp')) this.ensureLogo();
      this.bind();
      this.resize();
      this.reset();
      if (this.hasWon()) this.showWon(false, true); else this.setState('start');
      root.ppvFlappy = this;
      instances.add(this);
    }

    bind() {
      this.onPointer = (e) => {
        if (e.button > 0 || e.target.closest('button, a, input, .fl-card')) return;
        if (this.state !== 'ready' && this.state !== 'playing') return;
        e.preventDefault();
        this.stage.focus({ preventScroll: true });
        this.flap();
      };
      this.onClick = (e) => {
        const btn = e.target.closest('[data-fl]');
        if (!btn || !this.root.contains(btn)) return;
        const act = btn.getAttribute('data-fl');
        if (act === 'open') this.open(btn);
        else if (act === 'close') this.close();
        else if (act === 'play') { if (performance.now() >= this.lock) this.toReady(true); }
        else if (act === 'resume') this.resume();
        else if (act === 'copy') this.copy();
        else if (act === 'code') this.showWon(false);
      };
      this.stage.addEventListener('pointerdown', this.onPointer);
      this.root.addEventListener('click', this.onClick);
      if (this.dialog) {
        this.onClosed = () => this.closed();
        // nur schließen, wenn Drücken und Loslassen beide auf dem Hintergrund waren
        this.onDown = (e) => { this.downOnBackdrop = e.target === this.dialog; };
        this.onBackdrop = (e) => { if (e.target === this.dialog && this.downOnBackdrop) this.close(); this.downOnBackdrop = false; };
        this.dialog.addEventListener('close', this.onClosed);
        this.dialog.addEventListener('pointerdown', this.onDown);
        this.dialog.addEventListener('click', this.onBackdrop);
      }
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.resize());
        this.ro.observe(this.stage);
      } else {
        this.onResize = () => this.resize();
        window.addEventListener('resize', this.onResize);
      }
      if (this.home) {
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((es) => { this.inView = es[es.length - 1].isIntersecting; this.loop(); });
          this.io.observe(this.stage);
        } else this.inView = true;
      }
    }

    destroy() {
      cancelAnimationFrame(this.raf); this.raf = 0;
      clearTimeout(this.timer); clearTimeout(this.copyTimer);
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.dialog && this.dialog.open) this.close();
      this.stage.removeEventListener('pointerdown', this.onPointer);
      this.root.removeEventListener('click', this.onClick);
      if (this.dialog) {
        this.dialog.removeEventListener('close', this.onClosed);
        this.dialog.removeEventListener('pointerdown', this.onDown);
        this.dialog.removeEventListener('click', this.onBackdrop);
      }
      instances.delete(this);
      delete this.root.ppvFlappy;
    }

    hasWon() { return !!this.key && this.saved.won === this.key; }

    ensureLogo() {
      if (this.logoReq) return;
      this.logoReq = true;
      if (this.logoUrl) this.loadLogo(this.logoUrl);
    }

    // erst mit CORS (dann lässt sich der Rand abschneiden), sonst ohne
    loadLogo(url, retry) {
      const img = new Image();
      if (!retry) img.crossOrigin = 'anonymous';
      img.onload = () => { this.logo = trim(img); this.makeSprite(); this.render(); };
      img.onerror = () => {
        if (!retry) return this.loadLogo(url, true);
        this.logoFailed = true; this.makeSprite(); this.render();
      };
      img.src = url;
    }

    /* ---------- Größe & vorgerenderte Grafiken ---------- */

    resize() {
      const w = this.stage.clientWidth, h = this.stage.clientHeight;
      if (!w || !h) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const cw = Math.round(w * dpr), ch = Math.round(h * dpr);
      if (cw !== this.canvas.width || ch !== this.canvas.height) {
        this.canvas.width = cw; this.canvas.height = ch;
        this.k = Math.min(ch / H, cw / MIN_W);
        this.W = cw / this.k;
        this.oy = (ch / this.k - H) / 2;
        if (!this.pipes.length) { this.bx = Math.round(Math.min(this.W * 0.3, 230)); this.bird.x = this.bx; }
        this.paint();
      }
      this.render();
      this.loop();
    }

    paint() {
      const c = this.ctx, W = this.W, oy = this.oy, R = Math.max(W, H + 2 * oy);
      this.neb1 = c.createRadialGradient(0, -oy, 0, 0, -oy, R * 0.85);
      this.neb1.addColorStop(0, 'rgba(42,56,137,.13)'); this.neb1.addColorStop(1, 'rgba(42,56,137,0)');
      this.neb2 = c.createRadialGradient(W, H + oy, 0, W, H + oy, R * 0.8);
      this.neb2.addColorStop(0, 'rgba(196,170,120,.22)'); this.neb2.addColorStop(1, 'rgba(196,170,120,0)');
      this.body = c.createLinearGradient(-PIPE_W / 2, 0, PIPE_W / 2, 0);
      this.body.addColorStop(0, '#ffffff'); this.body.addColorStop(0.55, '#fdfdfe'); this.body.addColorStop(1, '#ececf0');
      this.cap = c.createLinearGradient(-CAP_W / 2, 0, CAP_W / 2, 0);
      this.cap.addColorStop(0, '#efe6d2'); this.cap.addColorStop(0.55, '#d6c39c'); this.cap.addColorStop(1, '#e6d9bd');
      this.makeSprite();
    }

    makeSprite() {
      // solange das Logo noch lädt, lieber keine Figur als kurz den Ersatz zeigen
      if (!this.logo && this.logoUrl && !this.logoFailed) { this.sprite = null; return; }
      const px = Math.max(8, Math.round(BIRD * this.k));
      const cv = document.createElement('canvas');
      cv.width = cv.height = px;
      const x = cv.getContext('2d'), src = this.logo;
      if (src) {
        const f = Math.min(px / src.sw, px / src.sh), w = src.sw * f, h = src.sh * f;
        x.imageSmoothingQuality = 'high';
        x.drawImage(src.img, src.sx, src.sy, src.sw, src.sh, (px - w) / 2, (px - h) / 2, w, h);
      } else {
        x.fillStyle = '#2b3fb8';
        rr(x, px * 0.06, px * 0.06, px * 0.88, px * 0.88, px * 0.24); x.fill();
        x.fillStyle = '#fff';
        x.font = '600 ' + Math.round(px * 0.56) + 'px -apple-system, "Segoe UI", Helvetica, Arial, sans-serif';
        x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText('P', px / 2, px * 0.53);
      }
      this.sprite = cv;
    }

    makeBlob() {
      const cv = document.createElement('canvas');
      cv.width = cv.height = 128;
      const x = cv.getContext('2d'), g = x.createRadialGradient(64, 64, 0, 64, 64, 64);
      g.addColorStop(0, 'rgba(255,255,255,.42)'); g.addColorStop(1, 'rgba(255,255,255,0)');
      x.fillStyle = g; x.fillRect(0, 0, 128, 128);
      this.blob = cv;
    }

    /* ---------- Zustände ---------- */

    setState(s) {
      this.state = s;
      this.stage.dataset.state = s;
      const show = { start: 'start', over: 'over', won: 'won', paused: 'pause' }[s];
      for (const name in this.ov) this.ov[name].hidden = name !== show;
      if (s === 'ready') this.t = 0;
      if (show) {
        const btn = this.ov[show].querySelector('.fl-btn');
        const active = (this.dialog && this.dialog.open) || this.root.contains(document.activeElement);
        if (btn && active) btn.focus({ preventScroll: true });
      }
      this.loop();
    }

    reset() {
      clearTimeout(this.timer);
      this.pipes = []; this.parts = []; this.score = 0; this.wonRun = false; this.flash = 0;
      this.bx = Math.round(Math.min(this.W * 0.3, 230));
      Object.assign(this.bird, { x: this.bx, y: H * 0.44, vy: 0, rot: 0 });
      this.restY = this.bird.y;
      this.el.score.textContent = '0';
      this.el.fill.style.width = '0%';
    }

    toReady(fresh) {
      if (fresh) this.reset();
      this.restY = this.bird.y;
      this.setState('ready');
      this.stage.focus({ preventScroll: true });
    }

    flap() {
      if (this.state === 'ready') { this.setState('playing'); this.spawn(); }
      if (this.state !== 'playing') return;
      this.bird.vy = FLAP;
      this.puff();
    }

    pause() { if (this.state === 'playing') this.setState('paused'); }

    resume() {
      if (this.state !== 'paused') return;
      this.bird.vy = 0;
      this.toReady(false);
    }

    point() {
      this.score++;
      this.el.score.textContent = this.score;
      this.el.fill.style.width = Math.min(100, this.score / this.target * 100) + '%';
      if (!motion.matches) { this.el.score.classList.remove('is-pop'); void this.el.score.offsetWidth; this.el.score.classList.add('is-pop'); }
      if (this.score >= this.target && !this.wonRun) this.win();
    }

    die() {
      this.setState('dying');
      if (!motion.matches) this.flash = 1;
      if (this.bird.vy < 0) this.bird.vy = 0;
    }

    gameOver() {
      this.saved = load();   // frisch lesen: ein anderer Tab könnte inzwischen gewonnen haben
      const prev = this.saved.best || 0, won = this.hasWon();
      this.saved.best = Math.max(prev, this.score);
      save(this.saved);
      this.el.msg.textContent = won ? 'Rabatt freigeschaltet' : 'Noch ' + Math.max(1, this.target - this.score) + ' bis zum Rabatt';
      this.el.final.textContent = this.score;
      this.el.best.textContent = this.score > prev ? 'Neuer Bestwert' : 'Bestwert ' + prev;
      this.el.best.hidden = !this.score && !prev;
      this.el.showCode.hidden = !won;
      this.setState('dead');
      this.announce('Vorbei. ' + this.score + (this.score === 1 ? ' Punkt.' : ' Punkte.'));
      this.timer = setTimeout(() => {
        this.lock = performance.now() + 380;
        this.setState('over');
      }, motion.matches ? 150 : 480);
    }

    win() {
      this.wonRun = true;
      this.saved = load();
      this.saved.won = this.key;
      this.saved.best = Math.max(this.saved.best || 0, this.score);
      save(this.saved);
      this.restY = clamp(this.bird.y - 24, 90, H - 220);
      this.setState('celebrate');
      this.confetti();
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ppv:flappy_won', { score: this.score, target: this.target }); } catch (e) {}
      this.root.dispatchEvent(new CustomEvent('ppv:flappy-won', { bubbles: true, detail: { score: this.score, target: this.target } }));
      this.timer = setTimeout(() => { this.lock = performance.now() + 380; this.showWon(true); }, motion.matches ? 200 : 1100);
    }

    // quiet = beim Seitenaufruf eines früheren Gewinners: nur anzeigen, nichts nachladen
    showWon(fresh, quiet) {
      this.el.wonTitle.textContent = fresh ? 'Geschafft' : 'Dein Rabatt';
      this.el.code.textContent = this.code || '–';
      this.setState('won');
      if (fresh) this.announce('Geschafft. Dein Rabattcode lautet ' + this.code + '.');
      if (!quiet) this.apply();
    }

    // Shopify merkt sich den Code über /discount/<code> und zieht ihn an der Kasse automatisch ab
    apply() {
      if (!this.autoApply || !this.code || this.applied) return;
      this.applied = true;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'discount/' + encodeURIComponent(this.code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
        .then((r) => { if (r.ok) this.el.note.textContent = 'Wird an der Kasse automatisch abgezogen.'; })
        .catch(() => {});
    }

    copy() {
      const label = this.el.copy;
      const done = () => {
        label.textContent = 'Kopiert';
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => { label.textContent = 'Code kopieren'; }, 2000);
      };
      const fallback = () => {
        const range = document.createRange(), sel = window.getSelection();
        range.selectNodeContents(this.el.code);
        sel.removeAllRanges(); sel.addRange(range);
        try { if (document.execCommand('copy')) done(); } catch (e) {}
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(this.code).then(done, fallback);
      else fallback();
      this.apply();
    }

    announce(text) {
      this.el.sr.textContent = '';
      setTimeout(() => { this.el.sr.textContent = text; }, 60);
    }

    /* ---------- Popup ---------- */

    open(opener) {
      if (!this.dialog) return;
      this.opener = opener || document.activeElement;
      this.ensureLogo();
      if (this.stage.parentNode !== this.slot) { this.pause(); this.slot.appendChild(this.stage); }
      if (!this.dialog.open) {
        if (this.dialog.showModal) this.dialog.showModal(); else this.dialog.setAttribute('open', '');
        this.overflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      this.resize();
      const show = { start: 'start', over: 'over', won: 'won', paused: 'pause' }[this.state];
      const btn = show && this.ov[show].querySelector('.fl-btn');
      (btn || this.stage).focus({ preventScroll: true });
      this.loop();
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;
      if (this.dialog.close) this.dialog.close();
      else { this.dialog.removeAttribute('open'); this.closed(); }
    }

    closed() {
      this.pause();
      document.documentElement.style.overflow = this.overflow || '';
      if (this.home && this.stage.parentNode !== this.home) this.home.appendChild(this.stage);
      if (fromHash(location.hash) === this) history.replaceState(history.state, '', location.pathname + location.search);
      if (this.opener && this.opener.focus && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
      this.opener = null;
    }

    keyActive() {
      return (this.dialog && this.dialog.open) || this.stage.contains(document.activeElement);
    }

    // Spieltasten nie an die Seite durchreichen (sonst scrollt die Leertaste), außer auf Buttons und Feldern
    onKey(e) {
      const flapKey = e.code === 'Space' || e.key === ' ' || e.code === 'ArrowUp' || e.code === 'KeyW';
      if (!flapKey || (e.target.closest && e.target.closest('button, a, input, textarea, select'))) return;
      e.preventDefault();
      if (e.repeat) return;
      if (this.state === 'ready' || this.state === 'playing') this.flap();
      else if (this.state === 'start') this.toReady(true);
      else if (this.state === 'paused') this.resume();
      else if (this.state === 'over' && performance.now() >= this.lock) this.toReady(true);
    }

    visibility() { if (document.hidden) this.pause(); else this.loop(); }

    /* ---------- Schleife ---------- */

    visible() {
      if (document.hidden || !this.stage.isConnected || !this.stage.clientWidth) return false;
      return this.stage.parentNode === this.slot ? !!(this.dialog && this.dialog.open) : this.inView;
    }

    loop() {
      if (this.raf || !this.visible()) return;
      this.last = performance.now();
      this.acc = 0;
      this.raf = requestAnimationFrame(this.frame);
    }

    // Feste Zeitschritte: auf 60-Hz- und 144-Hz-Bildschirmen gleich schnell.
    // raf bleibt während des Durchlaufs gesetzt, damit setState() in update() keine zweite Schleife startet.
    frame(now) {
      if (!this.visible()) { this.raf = 0; this.pause(); return; }
      this.acc += clamp((now - this.last) / 1000, 0, MAX_DT);
      this.last = now;
      while (this.acc >= STEP) { this.update(STEP); this.acc -= STEP; }
      this.render();
      this.raf = this.idle() ? 0 : requestAnimationFrame(this.frame);
    }

    // nichts bewegt sich mehr: nicht weiterzeichnen, loop() startet bei der nächsten Änderung neu
    idle() {
      const st = this.state;
      if (st === 'paused') return true;
      return motion.matches && !this.parts.length && !this.flash && st !== 'playing' && st !== 'dying' && st !== 'celebrate';
    }

    ramp() { return Math.min(1, this.score / RAMP); }
    speed() { return lerp(this.L.speed[0], this.L.speed[1], this.ramp()); }
    gap() { return lerp(this.L.gap[0], this.L.gap[1], this.ramp()); }

    spawn() {
      const p = this.pipes;
      let last = p[p.length - 1];
      while (!last || last.x < this.W + CAP_W) {
        const gap = this.gap(), lo = 80 + gap / 2, hi = H - FLOOR - 80 - gap / 2;
        const x = last ? last.x + this.L.spacing : Math.min(this.W + CAP_W, this.bird.x + 440);
        const from = last ? last.y : (lo + hi) / 2;
        last = { x, y: clamp(from + (Math.random() * 2 - 1) * this.L.shift, lo, hi), gap, scored: false, fade: x < this.W + CAP_W / 2 ? 0 : 1 };
        p.push(last);
      }
    }

    hits() {
      const b = this.bird;
      if (b.y + HIT_R >= H - FLOOR) return true;
      for (const p of this.pipes) {
        if (Math.abs(p.x - b.x) > CAP_W / 2 + HIT_R) continue;
        const top = p.y - p.gap / 2, bot = p.y + p.gap / 2;
        if (hitRect(b.x, b.y, HIT_R, p.x - PIPE_W / 2, -1e4, p.x + PIPE_W / 2, top - CAP_H) ||
            hitRect(b.x, b.y, HIT_R, p.x - CAP_W / 2, top - CAP_H, p.x + CAP_W / 2, top) ||
            hitRect(b.x, b.y, HIT_R, p.x - CAP_W / 2, bot, p.x + CAP_W / 2, bot + CAP_H) ||
            hitRect(b.x, b.y, HIT_R, p.x - PIPE_W / 2, bot + CAP_H, p.x + PIPE_W / 2, H)) return true;
      }
      return false;
    }

    update(dt) {
      const b = this.bird, st = this.state;
      if (st === 'paused') return;
      this.t += dt;
      if (!motion.matches) this.drift += dt;
      this.flash = Math.max(0, this.flash - dt * 4);
      this.stepParts(dt);

      // Schweben nur vor einer neuen Runde – nach "Weiter" bleibt die Figur still, sonst könnte sie in eine Säule wippen
      if (st === 'start' || st === 'ready') {
        const idle = !this.pipes.length && !motion.matches;
        b.y = this.restY + (idle ? Math.sin(this.t * 4.2) * 7 : 0);
        b.rot += (0 - b.rot) * Math.min(1, dt * 10);
        if (idle) this.floorX += this.speed() * dt;
        return;
      }
      if (st === 'celebrate') {
        b.vy = 0;
        b.y += (this.restY - b.y) * Math.min(1, dt * 5);
        b.rot += (0 - b.rot) * Math.min(1, dt * 8);
        return;
      }
      if (st !== 'playing' && st !== 'dying') return;

      b.vy = Math.min(b.vy + GRAVITY * dt, MAX_FALL);
      b.y += b.vy * dt;
      if (st === 'dying') {
        b.rot += (1.45 - b.rot) * Math.min(1, dt * 9);
        if (b.y >= H - FLOOR - HIT_R) { b.y = H - FLOOR - HIT_R; this.gameOver(); }
        return;
      }
      if (b.y < HIT_R - this.oy) { b.y = HIT_R - this.oy; if (b.vy < 0) b.vy = 0; }
      const want = b.vy < 0 ? -0.42 : Math.min(1.3, -0.42 + b.vy / MAX_FALL * 2);
      b.rot += (want - b.rot) * Math.min(1, dt * 12);

      const v = this.speed() * dt;
      this.floorX += v;
      for (const p of this.pipes) {
        p.x -= v;
        if (p.fade < 1) p.fade = Math.min(1, p.fade + dt * 3);
        if (!p.scored && p.x < b.x) {
          p.scored = true;
          this.point();
          if (this.state !== 'playing') return;
        }
      }
      while (this.pipes.length && this.pipes[0].x < -CAP_W) this.pipes.shift();
      this.spawn();
      if (this.hits()) this.die();
    }

    puff() {
      if (motion.matches) return;
      const b = this.bird;
      for (let i = 0; i < 4; i++) {
        this.parts.push({ x: b.x - 16, y: b.y + 8, vx: -70 - Math.random() * 90, vy: 30 + (Math.random() * 2 - 1) * 50,
          r: 2 + Math.random() * 3, life: 0, max: 0.45 + Math.random() * 0.3, c: i % 2 ? GOLD : BLUE, g: 0 });
      }
    }

    confetti() {
      if (motion.matches) return;
      const b = this.bird;
      for (let i = 0; i < 80; i++) {
        this.parts.push({ x: b.x, y: b.y, vx: (Math.random() * 2 - 1) * 320, vy: -180 - Math.random() * 460,
          w: 5 + Math.random() * 4, h: 8 + Math.random() * 6, rot: Math.random() * 6, vr: (Math.random() * 2 - 1) * 10,
          life: 0, max: 1.4 + Math.random() * 0.9, c: CONFETTI[i % CONFETTI.length], g: 900, rect: true });
      }
    }

    stepParts(dt) {
      const ps = this.parts;
      for (let i = ps.length - 1; i >= 0; i--) {
        const p = ps[i];
        p.life += dt;
        if (p.life >= p.max) { ps.splice(i, 1); continue; }
        p.vy += p.g * dt;
        p.x += p.vx * dt; p.y += p.vy * dt;
        if (p.rect) p.rot += p.vr * dt; else p.vx *= 0.985;
      }
    }

    /* ---------- Zeichnen ---------- */

    render() {
      const c = this.ctx, k = this.k, W = this.W, oy = this.oy, top = -oy, full = H + 2 * oy;
      if (!this.neb1) return;
      c.setTransform(k, 0, 0, k, 0, oy * k);
      c.fillStyle = '#f5f5f7'; c.fillRect(0, top, W, full);
      c.fillStyle = this.neb1; c.fillRect(0, top, W, full);
      c.fillStyle = this.neb2; c.fillRect(0, top, W, full);

      // weiche "Duftwolken" im Hintergrund
      const span = W + 320;
      for (let i = 0; i < 5; i++) {
        const r = 70 + (i % 3) * 30, sp = 10 + i * 4;
        const x = ((i * 0.23 * span - this.drift * sp) % span + span) % span - 160;
        c.drawImage(this.blob, x - r, 70 + ((i * 131) % 380) - r, r * 2, r * 2);
      }

      for (const p of this.pipes) this.drawPipe(p);

      // Boden
      c.fillStyle = '#eeeef1'; c.fillRect(0, H - FLOOR, W, FLOOR + oy);
      c.fillStyle = 'rgba(29,29,31,.10)'; c.fillRect(0, H - FLOOR, W, 1 / k);
      c.fillStyle = 'rgba(29,29,31,.07)';
      for (let x = -(this.floorX % 28); x < W; x += 28) { rr(c, x, H - FLOOR + 9, 12, 3, 1.5); c.fill(); }

      for (const p of this.parts) {
        const a = 1 - p.life / p.max;
        if (p.rect) {
          c.save(); c.translate(p.x, p.y); c.rotate(p.rot);
          c.globalAlpha = Math.min(1, a * 1.6); c.fillStyle = p.c;
          rr(c, -p.w / 2, -p.h / 2, p.w, p.h, 1.5); c.fill();
          c.restore();
        } else {
          c.fillStyle = p.c + (a * 0.45).toFixed(3) + ')';
          c.beginPath(); c.arc(p.x, p.y, p.r, 0, Math.PI * 2); c.fill();
        }
      }

      const b = this.bird;
      if (this.sprite) {
        c.save();
        c.translate(b.x, b.y); c.rotate(b.rot);
        c.shadowColor = 'rgba(43,63,184,.30)'; c.shadowBlur = 14 * k; c.shadowOffsetY = 6 * k;
        c.drawImage(this.sprite, -BIRD / 2, -BIRD / 2, BIRD, BIRD);
        c.restore();
      }

      if (this.flash > 0) { c.fillStyle = 'rgba(255,255,255,' + (this.flash * 0.6).toFixed(3) + ')'; c.fillRect(0, top, W, full); }
    }

    drawPipe(p) {
      const c = this.ctx, k = this.k, top = p.y - p.gap / 2, bot = p.y + p.gap / 2;
      c.save();
      c.translate(p.x, 0);
      c.globalAlpha = p.fade;
      c.shadowColor = 'rgba(18,18,18,.10)'; c.shadowBlur = 22 * k; c.shadowOffsetY = 8 * k;
      c.fillStyle = this.body;
      rr(c, -PIPE_W / 2, -this.oy - 40, PIPE_W, top - CAP_H + this.oy + 48, 14); c.fill();
      rr(c, -PIPE_W / 2, bot + CAP_H - 8, PIPE_W, H - bot - CAP_H + 48, 14); c.fill();
      c.fillStyle = this.cap;
      rr(c, -CAP_W / 2, top - CAP_H, CAP_W, CAP_H, 10); c.fill();
      rr(c, -CAP_W / 2, bot, CAP_W, CAP_H, 10); c.fill();
      c.shadowColor = 'transparent';
      c.fillStyle = 'rgba(255,255,255,.55)';
      c.fillRect(-CAP_W / 2 + 10, top - CAP_H + 4, CAP_W - 20, 1.5);
      c.fillRect(-CAP_W / 2 + 10, bot + 4, CAP_W - 20, 1.5);
      c.restore();
    }
  }

  const scan = (scope) => {
    (scope || document).querySelectorAll('[data-ppv-flappy]').forEach((el) => { if (!el.ppvFlappy) new Game(el); });
  };
  const find = (anchor) => {
    for (const g of instances) if (g.dialog && g.anchor === anchor) return g;
    return null;
  };
  const fromHash = (hash) => { try { return find(norm(decodeURIComponent((hash || '').slice(1)))); } catch (e) { return null; } };

  window.PPVFlappy = {
    scan,
    instances,
    open(anchor) { const g = anchor ? find(norm(anchor)) : [...instances].find((i) => i.dialog); if (g) g.open(); }
  };

  // Links auf #rabattspiel öffnen das Spiel – normale Klicks auf dieselbe Domain, kein Strg/Cmd-Klick, kein neuer Tab
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || !a.hash || e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (a.target && a.target !== '_self') || a.origin !== location.origin) return;
    const g = fromHash(a.hash);
    if (!g) return;
    e.preventDefault();
    g.open(a);
  });
  document.addEventListener('keydown', (e) => {
    for (const g of instances) if (g.keyActive()) { g.onKey(e); break; }
  });
  document.addEventListener('visibilitychange', () => instances.forEach((g) => g.visibility()));
  window.addEventListener('storage', (e) => { if (e.key === KEY) instances.forEach((g) => { g.saved = load(); }); });
  window.addEventListener('hashchange', () => { const g = fromHash(location.hash); if (g) g.open(); });
  motion.addEventListener && motion.addEventListener('change', () => instances.forEach((g) => g.render()));
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
  document.addEventListener('shopify:section:unload', (e) => instances.forEach((g) => { if (e.target.contains(g.root)) g.destroy(); }));

  scan();
  const g = fromHash(location.hash);
  if (g) setTimeout(() => g.open(), 250);
})();
